__turbopack_context__.v({
  "animatePopoverIn": "UI4cIa_animatePopoverIn",
  "animatePopoverOut": "UI4cIa_animatePopoverOut",
  "popover-animations": "UI4cIa_popover-animations",
});
